import { ReminderMessageCategory } from 'all-in-one-shared-api';
import dayjs from 'dayjs';

// import { changeDataFun } from 'utils/formate';

export interface NewsProps {
  title: string;
  description?: string;
  url?: string;
  imgSrc: string;
  imageUrlSquare?: string;
  // publishTime?: string;
}
export interface lifehomeNewsProps {
  imageUrl: string;
  title: string;
  chineseTitle: string;
  message: string;
  messageCategory?: ReminderMessageCategory;
  chineseMessage: string;
  link: string;
  chineseLink: string;
  imageUrlSquare?: string;
  // publishTime: string;
}
const MAXIMUM_NUMBER_OF_NEWS = 5;

export const formatNews = (
  news: lifehomeNewsProps[] | undefined,
  isEnglish: boolean,
  token: string,
  max?: number,
): NewsProps[] | undefined => {
  if (!news) return undefined;
  const ts = dayjs().format('YYYYMMDDHHmmssSSS');
  const formattedNews = news.map((newItem) => {
    const {
      title,
      chineseTitle,
      message,
      chineseMessage,
      link,
      chineseLink,
      imageUrl,
      imageUrlSquare,
      //  publishTime
    } = newItem;
    return {
      title: isEnglish ? title : chineseTitle,
      description: isEnglish ? message : chineseMessage,
      url: isEnglish ? link : chineseLink,
      // imgSrc: `${imageUrl}?token=${token}`,
      // imageUrlSquare: `${imageUrlSquare}?token=${token}`,
      imgSrc: `${imageUrl}?p=${ts}`,
      imageUrlSquare: `${imageUrlSquare}?p=${ts}`,
      // publishTime: isEnglish ? publishTime : changeDataFun(publishTime, true),
    };
  });
  // Note(Andy Chow): The news fetched from api is already ordered by Mesg_Priority. Maximum 5 news according to https://generali-hk.atlassian.net/browse/AIOBRB-1647
  return formattedNews.slice(0, max ? max : MAXIMUM_NUMBER_OF_NEWS);
};
